export default "__VITE_ASSET__CQ6g_mJQ__"